import { BlogSection } from '@/types/blog';

export const referenzen: BlogSection = {
  id: 'referenzen',
  title: 'Quellen & weiterführende Literatur',
  content: `
<p class="text-sm">Baumeister, R. F., Bratslavsky, E., Muraven, M. und Tice, D. M. (1998). Ego Depletion: Is the Active Self a Limited Resource? Journal of Personality and Social Psychology, 74(5), 1252–1265.</p>

<p class="text-sm">Porges, S. W. (2011). The Polyvagal Theory: Neurophysiological Foundations of Emotions, Attachment, Communication, and Self-regulation. W. W. Norton & Company.</p>

<p class="text-sm">Toomer, J., Caldwell, S., Weitzenkorn, S. und Clark, C. (2018). The Catalyst Effect: 12 Skills and Behaviors to Boost Your Impact and Elevate Team Performance. FranklinCovey.</p>

<p class="text-sm">McClelland, D. C. (1987). Human Motivation. Cambridge University Press.</p>

<p class="text-sm">Senge, P. M. (2006). The Fifth Discipline: The Art & Practice of The Learning Organization. Currency/Doubleday.</p>
  `
};
